<!-- wage-withdrawal-chart.component.html -->
<div class="chart-container">
    <!-- Date Range Filter -->
    <div class="filter-section">
        <div class="filter-group">
            <label for="startMonth" class="form-label">Start Month</label>
            <input type="month" id="startMonth" class="form-control" [(ngModel)]="startMonth" [max]="endMonth">
        </div>

        <div class="filter-group">
            <label for="endMonth" class="form-label">End Month</label>
            <input type="month" id="endMonth" class="form-control" [(ngModel)]="endMonth" [min]="startMonth">
        </div>

        <div class="filter-actions">
            <button type="button" class="btn btn-primary" (click)="onFilterApply()">
                <i class="bi bi-search"></i> Apply Filter
            </button>
            <button type="button" class="btn btn-secondary" (click)="onFilterReset()">
                <i class="bi bi-arrow-clockwise"></i> Reset
            </button>
        </div>
    </div>

    @if (error) {
    <div class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ error }}
    </div>
    }

    <!-- Chart -->
    <div class="chart-wrapper">
        <canvas #chartCanvas></canvas>
    </div>

    <!-- Summary Cards -->
    @if (summary && !error) {
    <div class="summary-cards">
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-cash-stack"></i> Total Withdrawals
                </h6>
                <p class="card-title value mb-0">{{ summary.totalWithdrawals }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-currency-dollar"></i> Total Amount
                </h6>
                <p class="card-title value mb-0">LKR {{ summary.totalWithdrawAmount | number:'1.2-2' }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-receipt"></i> Total Fees
                </h6>
                <p class="card-title value mb-0">LKR {{ summary.totalFees | number:'1.2-2' }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-graph-up"></i> Avg Withdrawal
                </h6>
                <p class="card-title value mb-0">LKR {{ summary.avgWithdrawAmount | number:'1.2-2' }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-people"></i> Unique Employees
                </h6>
                <p class="card-title value mb-0">{{ summary.uniqueEmployees }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-calendar-week"></i> Weeks Covered
                </h6>
                <p class="card-title value mb-0">{{ summary.weeksCovered }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-bar-chart"></i> Avg Weekly
                </h6>
                <p class="card-title value mb-0">{{ summary.avgWeeklyWithdrawals | number:'1.2-2' }}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">
                    <i class="bi bi-calendar-check"></i> Latest Withdrawal
                </h6>
                <p class="card-title value mb-0">{{ summary.latestWithdrawal | date: 'MMM d, y' }}</p>
            </div>
        </div>
    </div>
    }
</div>